import React, { useState } from "react";
import { Typography, Divider, Tag } from 'antd';
import {
    ClockCircleOutlined, HeartTwoTone
} from '@ant-design/icons';
import { Outlet, useNavigate, useParams, useSearchParams } from "react-router-dom";
import _ from "lodash";
import TextCover from "../3js/TextCover";
import ObjectCover from "../3js/ObjectCover";

const { Text } = Typography


export default function VideoCard(props) {


    const navigate = useNavigate()

    const handleDoubleClickItem = (i, k) => {
      window.open(props.vidUrl)
    }
    return (

        <div
            className='bql-card'  >
            <div className='bql-card-content' >
                {props.result && <div>
                    <Tag color={'#52c41a'}  >         {props.result}         </Tag>
                </div>
                }
                {/* <div style={{display:'flex', alignItem:'center'}} >dsdsd</div> */}
                <ObjectCover {...props} url={props.url} />
            </div>
            <div className='bql-card-name' >
                <div style={{ padding: 5 }} >
                    <div  >
                        <Text strong>{props.title}</Text>
                        <p />
                    </div>
                </div>
            </div>
            <Divider />
            <div className='bql-card-footer' >
                <div style={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5 }} >
                    {/* <div style={{ display: 'flex', alignItems: 'center', float: 'right' }}>
                        <HeartTwoTone twoToneColor='#FF0000' style={{ marginRight: 5 }} />
                        <Text type='secondary' style={{ fontSize: 12 }}>{' '}4</Text>
                    </div> */}
                    <Text strong style={{ fontSize: 14, float: 'left', height: 25 }}
                        onClick={handleDoubleClickItem.bind(this, props)}
                        className='view-pdf' >{' '}View Video</Text>
                </div>
            </div>

        </div>

    )
}

